import {NavItemsInterface} from '../interfaces/nav-items.interface';

export const navItems: NavItemsInterface[] = [
    {
      name: 'about',
      path: '/about',
    },
    {
      name: 'background',
      path: '/cv',
    },
    {
      name: 'portfolio',
      path: '/portfolio',
      childNodes: [
        {
          name: 'wikihikes',
          path: '/portfolio/wikihikes',
        },
        {
          name: 'photography',
          path: '/portfolio/photography',
        },
        {
          name: 'woodworking',
          path: '/portfolio/woodworking',
        },
        {
          name: 'ma college scorecard',
          path: '/portfolio/ma-college-scorecard',
        },
      ],
    },
    {
      name: 'contact',
      path: '/contact',
    },
  ];